import { render, staticRenderFns } from "./SModalNewClientCreator.vue?vue&type=template&id=160393ec&scoped=true"
import script from "./sModalNewClientCreator.ts?vue&type=script&lang=ts&external"
export * from "./sModalNewClientCreator.ts?vue&type=script&lang=ts&external"
import style0 from "./SModalNewClientCreator.vue?vue&type=style&index=0&id=160393ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160393ec",
  null
  
)

export default component.exports